// extracted by css-extract-rspack-plugin
export default {"ResidentialAddressForm":"sputnik__ResidentialAddressForm__mb_qT","residentialAddressForm":"sputnik__ResidentialAddressForm__mb_qT"};